import { IInvoice } from '../index'
import { IInvoiceData } from '../request/handleResponse'
import { mapItemToPrice } from '../../../utils/Money'

export default function(item: IInvoiceData): IInvoice {
  return {
    buyer: item.buyer_name,
    currency: item.currency,
    date: item.issue_date,
    link: item.link,
    number: item.number,
    price: mapItemToPrice(
      item.price && item.price.split('.')[1].length < 2
        ? `${item.price}0`
        : item.price,
    ),
    priceGross: mapItemToPrice(
      item.price_gross && item.price_gross.split('.')[1].length < 2
        ? `${item.price_gross}0`
        : item.price_gross,
    ),
  }
}
